// Single source of truth for the URL prefix the SPA is served under.
// Production serves at https://skedsocial.com/tools/traffic-snapshot
// (Vite `base` flips in vite.config.ts when CLOUDFLARE_ENV=production);
// staging + local dev serve at the host root, where BASE_PATH is "".
// The worker-side twin is the BASE_PATH var in wrangler.jsonc — the two
// must describe the same prefix or client fetches miss the worker.
export const BASE_PATH = import.meta.env.BASE_URL.replace(/\/$/, "");

// Prefix a root-relative app path ("/api/report") for fetch() targets and
// non-router navigations. React Router <Link>/navigate() don't need this —
// they inherit the prefix from <BrowserRouter basename>.
export function withBase(path: string): string {
  return BASE_PATH + path;
}

// Inverse of withBase: convert window.location.pathname into an
// app-relative path (used when persisting return_to targets the server
// later re-prefixes on redirect).
export function stripBase(pathname: string): string {
  if (!BASE_PATH) return pathname;
  if (pathname === BASE_PATH) return "/";
  return pathname.startsWith(BASE_PATH + "/") ? pathname.slice(BASE_PATH.length) : pathname;
}
